export type ScoreLevels = 'low' | 'medium' | 'high';

export const getScoreLevel = (score: number): ScoreLevels => {
  if (score <= 40) {
    return 'low';
  }

  if (score >= 65) {
    return 'high';
  }

  return 'medium';
};

/**
 * The single score-colour rule (IT-2274): every score ring, bar and number
 * takes its colour from here. The `--score-*` CSS tokens in styles/base.scss
 * mirror these values.
 */
export const SCORE_COLORS = {
  high: '#09E998',
  mid: '#39BEF8',
  needsAttention: '#FDCA40',
  low: '#FF144D',
} as const;

export type ScoreBand = keyof typeof SCORE_COLORS;

/**
 * Fixed bands: 0-40 low, 41-60 needs attention, 61-80 mid, 81-100 high. The
 * score is rounded first, so the colour matches the whole number the ring or
 * bar prints (40.4 reads "40" and is low). Anything that is not a number
 * counts as low.
 */
export const getScoreBand = (score: number): ScoreBand => {
  const rounded = Math.round(score);

  if (!(rounded > 40)) return 'low';
  if (rounded <= 60) return 'needsAttention';
  if (rounded <= 80) return 'mid';

  return 'high';
};

export const getScoreColor = (score: number): string =>
  SCORE_COLORS[getScoreBand(score)];
